// extracted by mini-css-extract-plugin
module.exports = {"skills":"Skills_skills__1faZd","line":"Skills_line__1_u9Y","skillElement":"Skills_skillElement__38qqy","mySkillPadding":"Skills_mySkillPadding__77JOJ"};